import React, { memo, useCallback, useMemo, useState, forwardRef, useImperativeHandle } from 'react'
import { SettingOutlined } from '@ant-design/icons'
import { ButtonStyled } from './style'
import TableSettingsModal from '../table-settings-modal/table-settings-modal'
import { TableColumnItem } from '../../model/types/types'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isJsonSettingsByKey } from '../../model/selectors/store'
import { Tooltip } from 'antd'

interface TableSettingsButtonProps {
  items: TableColumnItem[]
  settingsKey?: string
  mainKeys?: string[]
  initialKeys?: string[]
  allColumnsLabel?: string
}

export interface TableSettingsButtonRef {
  open: () => void
}

export const TableSettingsButton = memo(
  forwardRef<TableSettingsButtonRef, TableSettingsButtonProps>(
    ({ items, settingsKey, mainKeys, initialKeys, allColumnsLabel }, ref) => {
      const [isOpen, setIsOpen] = useState(false)
      const { pathname } = useLocation()
      const key = settingsKey || pathname
      const isSettings = useSelector(state => isJsonSettingsByKey(state, key))
      const tooltipTitle = useMemo(
        () =>
          isSettings
            ? 'Применены индивидуальные настройки'
            : 'Индивидуальные настройки для отображения столбцов',
        [isSettings],
      )

      const onCloseModal = useCallback(() => {
        setIsOpen(false)
      }, [])

      const onOpenModal = useCallback(() => {
        setIsOpen(true)
      }, [])

      useImperativeHandle(ref, () => ({
        open: onOpenModal,
      }))

      if (!items) {
        return null
      }

      return (
        <>
          <Tooltip title={tooltipTitle} placement="topRight">
            <ButtonStyled
              aria-label="Настроить колонки"
              icon={<SettingOutlined />}
              onClick={onOpenModal}
            />
          </Tooltip>
          {isOpen && (
            <TableSettingsModal
              isOpen={isOpen}
              items={items}
              settingsKey={key}
              mainKeys={mainKeys}
              initialKeys={initialKeys}
              allColumnsLabel={allColumnsLabel}
              onCancel={onCloseModal}
            />
          )}
        </>
      )
    },
  ),
)
